// extracted by mini-css-extract-plugin
module.exports = {"padding":"padding_padding__gey1i"};